<template>
  <b-modal ref="confirmModal" hide-footer :title="title">
    <div class="d-block text-center">
      <p v-html="formattedMessage"></p>
      <b-button
        class="mr-1"
        :variant="cancelButtonVariant"
        @click="handleCancel"
      >
        {{ cancelButtonLabel }}
      </b-button>
      <b-button
        class="ml-1"
        :variant="confirmButtonVariant"
        @click="handleConfirm"
      >
        {{ confirmButtonLabel }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
  export default {
    name: 'ModalConfirm',
    data() {
      return {
        title: '',
        message: '',
        confirmButtonLabel: 'Confirmer',
        cancelButtonLabel: 'Annuler',
        confirmButtonVariant: 'danger',
        cancelButtonVariant: 'outline-secondary',
        resolve: null,
        reject: null,
      }
    },
    computed: {
      formattedMessage() {
        return this.message.replace(/\n/g, '<br />')
      },
    },
    methods: {
      open(title, message, options = {}) {
        this.title = title
        this.message = message
        this.confirmButtonLabel = options.confirmButtonLabel || 'Confirmer'
        this.cancelButtonLabel = options.cancelButtonLabel || 'Annuler'
        this.confirmButtonVariant = options.confirmButtonVariant || 'danger'
        this.cancelButtonVariant =
          options.cancelButtonVariant || 'outline-secondary'
        this.$refs.confirmModal.show()

        return new Promise((resolve, reject) => {
          this.resolve = resolve
          this.reject = reject
        })
      },
      handleConfirm() {
        this.resolve(true)
        this.$refs.confirmModal.hide()
      },
      handleCancel() {
        this.resolve(false)
        this.$refs.confirmModal.hide()
      },
    },
  }
</script>
